/* eslint-disable no-return-assign */
import PropTypes from 'prop-types';
import React from 'react';
import GifPlayer from 'react-gif-player';
import AudioContainer from '../audio/audioContainer';
import FullPageLayout from '../layouts/fullPageLayout';
import owlyCelebration from '../../images/owl/owlyCelebration.gif';

const GIF_DURATION_MS = 4500;
class OwlyInterstitialView extends React.Component {

    componentDidMount() {
        this.props.playAudio();
        setTimeout(this.pauseGif, GIF_DURATION_MS);
    }

    render() {
        return (
            <div>
                <FullPageLayout>
                    <div className="owly-celebration-gif-container">
                        <GifPlayer autoplay gif={owlyCelebration} pauseRef={pause => this.pauseGif = pause} alt="owly celebrating" />
                        <AudioContainer />
                    </div>
                </FullPageLayout>
            </div>
        );
    }

};

OwlyInterstitialView.propTypes = {
    playAudio: PropTypes.func.isRequired,
};

export default OwlyInterstitialView;
